import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const MetricSelectionTree = ({ selectedMetrics, onChange }) => {
  const metrics = [
    {
      id: 'pngEmploymentAct',
      label: 'PNG Employment Act Compliance',
      description: 'Minimum wage, working hours, termination procedures',
      icon: 'FileCheck'
    },
    {
      id: 'nasfundAdherence',
      label: 'NASFUND Adherence Rates',
      description: 'Contribution accuracy, filing timeliness',
      icon: 'DollarSign'
    },
    {
      id: 'swtAccuracy',
      label: 'SWT Accuracy Metrics',
      description: 'Tax calculation, withholding compliance',
      icon: 'Calculator'
    },
    {
      id: 'leavePolicyViolations',
      label: 'Leave Policy Violations',
      description: 'Annual leave, sick leave, public holidays',
      icon: 'Calendar'
    },
    {
      id: 'payrollCompliance',
      label: 'Payroll Compliance Indicators',
      description: 'Payment timeliness, calculation accuracy',
      icon: 'Wallet'
    }
  ];

  const handleToggle = (metricId) => {
    onChange({
      ...selectedMetrics,
      [metricId]: !selectedMetrics?.[metricId]
    });
  };

  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-3">
        Select Metrics
      </label>
      <div className="space-y-3">
        {metrics?.map((metric) => (
          <div
            key={metric?.id}
            className="bg-muted/30 rounded-lg p-3 hover:bg-muted/50 transition-colors"
          >
            <div className="flex items-start gap-3">
              <Checkbox
                checked={selectedMetrics?.[metric?.id] || false}
                onChange={() => handleToggle(metric?.id)}
              />
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <Icon name={metric?.icon} size={16} color="var(--color-primary)" />
                  <span className="text-sm font-medium text-foreground">
                    {metric?.label}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground">
                  {metric?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetricSelectionTree;